import React, {Fragment} from 'react';
import {Helmet} from 'react-helmet';
import Breadcrumbs from '@homeaway/react-breadcrumbs';
import {Link} from 'react-router-dom';

import './Breadcrumbs.less';

const BreadcrumbWrapper = ({crumbs, hostname}) => {
    const routedCrumbs = crumbs.map((crumb) => {
        crumb.node = <Link to={crumb.url} />;
        return crumb;
    });

    const generateBreadcrumbSchema = `{
        "@context": "http://schema.org",
        "@type": "BreadcrumbList",
        "itemListElement": [${crumbs.map((crumb, index) => {
            return `
            {
                "@type": "ListItem",
                "position": ${index + 1},
                "name": "${crumb.name}",
                "item": "https://${hostname}${crumb.url}"
            }
                `;
        })}]
    }`;

    return (
        <Fragment>
            <Helmet>
                <script type="application/ld+json">
                    {generateBreadcrumbSchema}
                </script>
            </Helmet>
            <Breadcrumbs crumbs={routedCrumbs} isLastCrumbLinked />
        </Fragment>
    );
};

export default BreadcrumbWrapper;
